let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7FeRF")).then(() => parcelRequire('2s0Tm'));